<template>
  <div ref="accountSwitcherElement" class="s-accountSwitcher bg-vio pa-2">
    <div class="s-accountSwitcher__meta">
      <Translation keypath="account.login.offeredByKeeunit" tag="div" class="text-h4 text-white text-center">
        <template #link>
          <a :href="`https://keelearning.de`" target="_blank" rel="noopener noreferrer">{{ $t("account.login.keeunit") }}</a>
        </template>
      </Translation>
      <ReviewLink class="s-accountSwitcher__reviewLink text-white" />
    </div>

    <k-button v-if="accountStore.isSuperAdmin" block to="/appswitcher">
      {{ $t("topNavigation.appSwitcher") }}
      <v-tooltip activator="parent"><span class="text-white">ctrl+alt+k</span></v-tooltip>
    </k-button>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue"
import { useElementSize } from "@vueuse/core"

import ReviewLink from "@/modules/account/components/ReviewLink.vue"
import { useAccountStore } from "@/modules/account/store"

const emit = defineEmits<{
  measuredHeightChange: [heightInPx: number]
}>()

const accountStore = useAccountStore()
const accountSwitcherElement = ref<HTMLElement | null>(null)
const { height: measuredAccountSwitcherHeightInPx } = useElementSize(accountSwitcherElement)

watch(
  measuredAccountSwitcherHeightInPx,
  (heightInPx) => {
    emit("measuredHeightChange", heightInPx)
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
.s-accountSwitcher {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 240px;
  z-index: 999;
}

.s-accountSwitcher__meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.s-accountSwitcher__reviewLink {
  justify-content: center;
}
</style>
